<template>
    <div>
        <div class="radioCheckContainer">
        <p v-for="error in errors.collect(question.id)" :key="error" class="errorText">
            {{ error }}
        </p>
        <input 
            :id="question.id"
            type="checkbox" 
            v-model="item.propertyValue" 
            value="TRUE" 
            :class="{'error': errors.has(question.id)}"
            v-validate="{rules: {'required': question.required}}"
            :name="question.id">
        <label :for="question.id">&nbsp;</label>
        </div>
    </div>
</template>
<script>
	export default {
		name: 'profileBooleanEditor',
		props: {
            item: Object,
            question: Object
        },
        data: function() {
            if (this.item.propertyValue == null) {
                this.item.propertyValue = "FALSE";
            }
        	return {
                internItem: this.item
        	}
        },
        inject: ['$validator'],
        mounted: function() {
            this.$validator.validate('' + this.question.id);
        },
        watch: {
            internItem: {
                handler: function(oldValue, newValue) {
                    this.$emit('updateValue', this.question);
                },
                deep: true
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileBooleanEditor.vue?43778295